<template>
  <div class="tab-main tab-view">
    <Confetti class="confetti" ref="confettiRef" />
    <div class="user">
      <div class="user-name">
        <div class="user-image">{{ userName[0].toUpperCase() }}</div>
        {{ userName }}
      </div>
      <div class="user-passes">{{ userStore.user?.passes }}
        <IconPass />
      </div>
    </div>
    <div class="main-balance">
      <IconLP class="icon" />
      <Balance :balance="userStore.user?.balance.toString() || ''" />
    </div>
    <TapTap ref="taptapRef" @success="onSuccess" :farming="!!userStore.farming" />
    <FarmingBar v-if="!!userStore.farming" :farming="userStore.farming" @claim="claim" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { hapticService } from '@/services/haptic.service'
import { useUserStore } from '@/stores/user'

import Confetti from './Confetti.vue'
import TapTap from '@/components/TapTap.vue'
import FarmingBar from '@/components/FarmingBar.vue'
import Balance from '@/components/Balance.vue'
import IconPass from '@/components/Icons/IconPass.vue'
import IconLP from '@/components/Icons/IconLP.vue'

const userStore = useUserStore()

const confettiRef = ref()

const taptapRef = ref()

const userName = window.Telegram.WebApp.initDataUnsafe.user?.username ?? 'TestUser'

const onSuccess = async () => {
  hapticService.vibrateSuccess()
  confettiRef.value.explode()
  await userStore.startFarming()
}

const claim = async () => {
  hapticService.vibrateSuccess()
  confettiRef.value.explode()
  taptapRef.value.clearCurrent()
  const response = await userStore.stopFarming()
}
</script>

<style lang="scss" scoped>
.back-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  // transform: scale(1.5);
}

.tab-main {
  width: 100vw;
  height: calc(100vh - 80px);
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 1;
  position: relative;

  .confetti {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .main-balance {
    align-self: center;
    margin-bottom: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 30px;

    .icon {
      margin-bottom: 10px;

      @media (max-height: 550px) {
        width: 25px;
        height: 25px;
      }

      @media (min-height: 550px) {
        width: 30px;
        height: 30px;
      }

      @media (min-height: 650px) {
        width: 50px;
        height: 50px;
      }
    }

    @media (max-height: 550px) {
      margin-top: 0;
      font-size: 12px
    }

    @media (min-height: 550px) {
      margin-top: 30px;
    }

    @media (min-height: 650px) {
      margin-top: 60px;
    }
  }

  .user {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .user-name {
      display: flex;
      gap: 10px;
      align-items: center;
      font-family: 'Forma DJR Display';
      font-weight: 700;
      letter-spacing: 0.03em;

      .user-image {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        background-color: var(--blue-color);
        color: white;
        display: flex;
        align-items: baseline;
        justify-content: center;
        align-items: center;
        font-family: 'Forma DJR Display';
        font-weight: 700;
      }
    }

    .user-passes {
      font-family: 'Forma DJR Display';
      font-weight: 700;
      display: flex;
      align-items: center;
      gap: 10px;

      .icon {
        fill: var(--black-color);
        height: 20px;
        width: 20px;
      }
    }
  }
}
</style>
